import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, filter, switchMap } from 'rxjs/operators';
import { BaseHttpService } from './basehttpservice';
import { PersistenceService } from '@services/persistence.service';
import { ExistsDto } from '@models/exists';


/**
 * Service for handling tenant data. NOTE! This won't work if there's no routing action that has happened (Guard works).
 */
@Injectable({
  providedIn: 'root'
})
export class TenantService extends BaseHttpService {
  private tenant: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private persistenceService: PersistenceService
  ) {
    super();

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => this.activatedRoute.root.firstChild),
      switchMap(firstChild =>
        firstChild.paramMap.pipe(
          map(paramMap => paramMap.get('tenant'))
        )
      )
    ).subscribe(tenant => {
      this.tenant = tenant;
    });
  }

  /**
   * Get active tenant data. Use activeTenantFromRoute where possible for more stability.
   */
  public get activeTenant(): string {
    return this.tenant;
  }

  /**
   * Get active tenant from the given route snapshot. Should be used where possible.
   * @param route The route snapshot from where the call was made.
   */
  public activeTenantFromRoute(route: ActivatedRouteSnapshot): string {
    return route.params.tenant;
  }

  public tenantExists(alias: string): Observable<boolean> {
    let storedTenant: string = this.persistenceService.get('avux-tenant-last');

    //If the tenant is the last visited, skip check and return true.
    if (storedTenant && storedTenant == alias) {
      return of(true);
    }
    // Otherwise do the check and save to persistence storage if tenant exists.
    return this.checkTenantExists(alias).pipe(
      map(tenant => {
        if (tenant.exists) {
          this.persistenceService.set('avux-tenant-last', alias);
        }
        return tenant.exists;
      })
    );

  }

  /**
   * Checks if the tenant exists from API.
   * @param alias Alias of the tenant that will be checked.
   */
  private checkTenantExists(alias: string): Observable<ExistsDto> {
    return this.httpClient.get<ExistsDto>(`${this.getUrl()}/Tenant/exists/${alias}`);
  }
}
